import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../redux/store";

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isRegistrationComplete, isPassedOptional } =
    useSelector((state: RootState) => state.user);

  if (isAuthenticated && isRegistrationComplete && isPassedOptional) {
    return <Navigate to="/" replace />;
  }
 
  return <>{children}</>;
};

export default PublicRoute;
